<div
    class="results-container"
    [class.view-tiles]="view() === 'tiles'"
    [class.count-1]="count() === 1"
    [class.count-2]="count() === 2"
    [style.max-width.rem]="view() !== 'tiles' || count() <= 2 ? width() / 16 : null"
>
    <ng-content></ng-content>
</div>
